import React from 'react';

export const EditBlueIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M4.16675 12.8698V14.6991C4.16675 14.8676 4.29914 15 4.46763 15H6.29701C6.37524 15 6.45347 14.9699 6.50763 14.9098L13.0789 8.34446L10.8223 6.08783L4.25701 12.6531C4.19684 12.7133 4.16675 12.7855 4.16675 12.8698ZM14.8241 6.59934C15.0588 6.36465 15.0588 5.98553 14.8241 5.75084L13.4159 4.3427C13.1812 4.10801 12.8021 4.10801 12.5674 4.3427L11.4662 5.44394L13.7228 7.70057L14.8241 6.59934Z"
      fill="#27B0E0"
    />
  </svg>
);
